import { HStack } from '@chakra-ui/react';

import ProductProviderTag from './ProductProviderTag';
import ProductProximityTag from './ProductProximityTag';

const ProductTags = ({ product, ...props }) => {
  return (
    <HStack>
      <ProductProximityTag proximity={product.proximity} locality={product.locality} {...props} />
      <ProductProviderTag providerName={product.provider_name} maxW="300px" {...props} />
    </HStack>
  );
};

export default ProductTags;
